import { Alert, Box, Button, Stack } from '@mui/material';
import { white } from '@styles/colors';
import React, { FC, useState } from 'react';
import AddQuestionsModal from './AddQuestionsModal';
import TemplateQuestionsCard from './TemplateQuestionsCard';
import { ApplicationQuestion } from '@features/applicationQuestions';
import { useGetTemplateTagsList } from '../hooks/useGetTemplateTagsList';
import { Add } from '@mui/icons-material';
import { EnterpriseTemplate } from '../types';
import { getCookie } from '@utils/getCookie';
import ConfirmationModal from './ConfirmationModal';

type TemplateQulificationQuestionsProps = {
  templateData: EnterpriseTemplate;
};

const TemplateQulificationQuestions: FC<TemplateQulificationQuestionsProps> = ({
  templateData,
}) => {
   const dontShowWarningPopup = getCookie('dontShowWarningPopup');
    const isAppliedChanges = templateData.apply_changes && !dontShowWarningPopup;
  const [addQuestionModal, setAddQuestionModal] = useState(false);
   const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [errorText, setErrorText] = useState('');
  const { tagsList } = useGetTemplateTagsList({
    enabled: true,
    setErrorText,
    templateId: templateData?.id,
  });
  const handleConfirm = () => {
    setIsConfirmOpen(false);
    setAddQuestionModal(true);
  };
  const handleCancel = () => {
    setIsConfirmOpen(false);
  };
  return (
    <Stack spacing={2}>
      <Button
        variant="contained"
        color="success"
        startIcon={<Add />}
        size="small"
        onClick={() => {
          if (isAppliedChanges) {
            setIsConfirmOpen(true);
          }else{
            setAddQuestionModal(true)
          }
        }}
        sx={{ textAlign: 'end', alignSelf: 'end', width: 'fit-content' }}
      >
        Add a Question
      </Button>
      <Stack spacing={3} bgcolor={white} p={3} borderRadius={8} width="100%">
        {templateData?.qualification_questions &&
        templateData?.qualification_questions?.length > 0 ? (
          templateData?.qualification_questions.map(
            (applicationQuestion: ApplicationQuestion) => {
              return (
                <TemplateQuestionsCard
                  applicationQuestion={applicationQuestion}
                  templateData={templateData}
                  tagsList={tagsList}
                />
              );
            },
          )
        ) : (
          <Box display="flex" justifyContent="center" textAlign="center">
            <Alert severity="info" sx={{ maxWidth: 'sm' }}>
              No questions here! <br />
              Application questions give you a chance to pre-screen and even
              pre-qualify candidates when they apply. We've got several
              pre-drafted questions available, or you can create your own!
            </Alert>
          </Box>
        )}
      </Stack>
      <AddQuestionsModal
        isOpen={addQuestionModal}
        applicationQuestion={null}
        templateId={templateData?.id}
        jobPostingsData={templateData?.job_listing}
        tagsList={tagsList}
        handleClose={() => {
          setAddQuestionModal(false);
        }}
      />
      <ConfirmationModal
              open={isConfirmOpen}
              onConfirm={handleConfirm}
              onCancel={handleCancel}
            />
    </Stack>
  );
};

export default TemplateQulificationQuestions;
